const Reflux = require('@muzzylane/reflux');
const get = require('lodash/get');
const uuid = require('uuid');
const _ = {
    filter: require('lodash/filter'),
    find: require('lodash/find'),
    findIndex: require('lodash/findIndex'),
    reject: require('lodash/reject'),
    union: require('lodash/union'),
    forEach: require('lodash/forEach'),
};

const Globals = require('../../../app/globals');

const ForgeError = require('../util/error');
const RSDActions = require('../actions/RSDActions');

let channelRSDServices = {}; // channelRSDServices[channelId] = data about rsd templates available to the channel user

let initializedOrgServices = {};
let orgRSDServices = {}; // orgRSDServices[orgId] = array of rsd services for the org 
let orgRSDs = {}; // orgRSDs[org][service_id] = array of rsd objects for internal rsd services (service_type MZL)
let external_rsds = []; // array of RSD information retrieved from an external rsd service

let action = {};


const RSDStore = Reflux.createStore({
    listenables: [RSDActions],
    init: function() {},

    resetState: function() {
        initializedOrgServices = {};
        orgRSDServices = {};
        orgRSDs = {};

        channelRSDServices = {};
        
        external_rsds = [];
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            orgRSDServices, initializedOrgServices,
            channelRSDServices,
            external_rsds,
            action,
        };
    },

    getStateChannel: function(channelId) {
        return {
            rsdServices: get(channelRSDServices, `${channelId}`, {}),
            external_rsds: external_rsds, // external RSD data (id, name, description) that we have cached
            action: action,
        }
    },

    // convenience function to obtain array of rsds for a given rsd_service_id if the data is present
    // returns undefined if not
    getStateChannelRSDS: function(channelId, rsd_service_id) {
        let rsdServices = get(channelRSDServices, `${channelId}`, {});
        if (!rsdServices.rsd_services) {
            return;
        }
        let serviceData = _.find(rsdServices.rsd_services,{id:rsd_service_id});
        if (!serviceData) {
            return;
        }
        if (serviceData.service_type !== Globals.RSD_SERVICE_TYPES.MZL) {
            return _.filter(external_rsds,{rsd_service_id});
        }
        
        if (rsdServices.rsds) {
            return rsdServices.rsds[rsd_service_id];
        }
    },

    getStateOrg: function(orgId) {
        return {
            rsdServicesInitialized: this.getOrgServicesInitialized(orgId),
            rsdServices: get(orgRSDServices, `${orgId}`, []),
            rsds: get(orgRSDs,`${orgId}`, {}), // internal external_rsds
            external_rsds: external_rsds, // external external_rsds that we have cached
            action: action,
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
    },

    getOrgServicesInitialized(orgId) {
        const pOrgId = parseInt(orgId, 10);
        return initializedOrgServices[orgId];
    },

    onError: function(actionId, err) {
        action.id = actionId;
        if (err.status) {
            switch (err.status) {
                default:
                    action.error = new ForgeError({ message: err.responseText, stack: null }); // assume short course related requests provide user-facing error text
                    break;
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },
    

    onGetRSDServicesCompleted: function(actionId, orgId, rsdServiceArr) {
        action = { id: actionId };
        const pOrgId = parseInt(orgId, 10);
        orgRSDServices[pOrgId] = rsdServiceArr;
        initializedOrgServices[pOrgId] = true;
        this.emitStatus();
    },

    onGetRSDServicesFailed: function(actionId, orgId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddRSDServiceCompleted: function(actionId, orgId, rsdServiceData) {
        action = { id: actionId };
        const pOrgId = parseInt(orgId, 10);
        let rsdServices = orgRSDServices[pOrgId];
        let index = _.findIndex(rsdServices,{id: rsdServiceData.id});
        if (index >= 0) {
            console.log(`onAddRSDServiceCompleted already had id ${rsdServiceData.id}`);
        }
        else {
            rsdServices.push(rsdServiceData);
        }
        this.emitStatus();
    },

    onAddRSDServiceFailed: function(actionId, orgId, err) {
        console.log("onAddRSDServiceFailed:",err); // FIXME: remove debug spam
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    
    onUpdateRSDServiceCompleted: function(actionId, orgId, rsdServiceData) {
        action = { id: actionId };
        const pOrgId = parseInt(orgId, 10);
        let rsdServices = orgRSDServices[pOrgId];
        let index = _.findIndex(rsdServices,{id: rsdServiceData.id});
        if (index >= 0) {
            rsdServices[index] = rsdServiceData;
        }
        else {
            console.log(`onUpdateRSDServiceCompleted failed to find id ${rsdServiceData.id}`);
        }
        this.emitStatus();
    },

    onUpdateRSDServiceFailed: function(actionId, orgId, err) {
        console.log("onUpdateRSDServiceFailed:",err); // FIXME: remove debug spam
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetOrgServiceRSDsCompleted: function(actionId, params, result) {
        action = { id: actionId };
        const { orgId, rsd_service_id } = params;
        if (typeof orgRSDs[orgId] === 'undefined') {
            orgRSDs[orgId] = {};
        }
        orgRSDs[orgId][rsd_service_id] = result;
        this.emitStatus();
    },
    onGetOrgServiceRSDsFailed: function(actionId, err) {
        console.log("onGetOrgServiceRSDsFailed",err); // FIXME: remove debug spam
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddRSDCompleted: function(actionId, params, result) {
        action = { id: actionId };
        const { orgId, rsd_service_id } = params;
        if (typeof orgRSDs[orgId] === 'undefined') {
            orgRSDs[orgId] = {};
        }
        let {rsd_id, name, description } = result;
        let rsds = orgRSDs[orgId][rsd_service_id] || [];
        if (!_.find(rsds,{id: rsd_id})) {
            let rsd = {
                id: rsd_id,
                name,
                description
            };
            rsds.push(rsd);
            orgRSDs[orgId][rsd_service_id] = rsds;
        }
        
        this.emitStatus();
    },
    onAddRSDFailed: function(actionId, params, err) {
        console.log("onAddRSDFailed",err); // FIXME: remove debug spam
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateRSDCompleted: function(actionId, params, result) {
        action = { id: actionId };
        const { orgId, rsd_service_id, rsd_id } = params;
        if (typeof orgRSDs[orgId] === 'undefined') {
            orgRSDs[orgId] = {};
        }
        if (!orgRSDs[orgId][rsd_service_id]) {
            orgRSDs[orgId][rsd_service_id] = [];
        }
        let { name, description} = result;
        let rsd = {
            id: rsd_id,
            name,
            description
        };
        let index = _.findIndex(orgRSDs[orgId][rsd_service_id],{id: rsd_id});
        if (index >= 0) {
            orgRSDs[orgId][rsd_service_id][index] = rsd;
        }
        else {
            orgRSDs[orgId][rsd_service_id].push(rsd);
        }
        this.emitStatus();
    },
    onUpdateRSDFailed: function(actionId, params, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },




    onGetChannelRSDServicesCompleted: function(actionId, channelId, rsdServiceArr) {
        action = { id: actionId };
        if (typeof channelRSDServices[channelId] === 'undefined') {
            channelRSDServices[channelId] = {};
        }
        channelRSDServices[channelId].rsd_services = rsdServiceArr;
        this.emitStatus();
    },

    onGetChannelRSDServicesFailed: function(actionId, err) {
        console.log("onGetChannelRSDServicesFailed",err); // FIXME: remove debug spam
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetNameAndDescriptionCompleted: function(actionId, params, result) {
        action = { id: actionId };
        if (result.invalid) {
            action.error = "invalid";
        }
        else {
            let rsd = {
                rsd_id: params.rsd_id,
                rsd_service_id: params.rsd_service_id,
                name: result.name,
                description: result.description,
            }
            let existing_index = _.findIndex(external_rsds,{rsd_id:params.rsd_id, rsd_service_id: params.rsd_service_id});
            if (existing_index >= 0) {
                external_rsds[existing_index] = rsd;
            }
            else {
                external_rsds.push(rsd);
            }
        }
        this.emitStatus();
    },
    
    onGetNameAndDescriptionFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onFindMatchingServicesCompleted: function(actionId, params, matching_services) {
        action = { id: actionId };
        const { channelId, rsd_ids } = params;
        if (typeof channelRSDServices[channelId] === 'undefined') {
            channelRSDServices[channelId] = {};
        }
        // merge previous and new results
        _.forEach(channelRSDServices[channelId].matching_services,(old_matching_rsd_ids,rsd_service_id)=>{
            let new_matching_rsd_ids = matching_services[rsd_service_id];
            if (!new_matching_rsd_ids) {
                matching_services[rsd_service_id] = old_matching_rsd_ids;
            }
            else {
                matching_services[rsd_service_id] = _.union(old_matching_rsd_ids, new_matching_rsd_ids);
            }
        });
        channelRSDServices[channelId].matching_services = matching_services;
        this.emitStatus();
    },
    
    onFindMatchingServicesFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetChannelServiceRSDsCompleted: function(actionId, params, result) {
        action = { id: actionId };
        const { channelId, rsd_service_id } = params;
        if (typeof channelRSDServices[channelId] === 'undefined') {
            channelRSDServices[channelId] = {};
        }
        if (typeof channelRSDServices[channelId].rsds === 'undefined') {
            channelRSDServices[channelId].rsds = {};
        }
        channelRSDServices[channelId].rsds[rsd_service_id] = result;
        this.emitStatus();
    },
    onGetChannelServiceRSDsFailed: function(actionId, err) {
        console.log("onGetChannelServiceRSDsFailed",err); // FIXME: remove debug spam
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onBatchLookupCompleted: function(actionId, params, batchResults) {
        action = { id: actionId };
        const channelId = params.channelId;
        if (typeof channelRSDServices[channelId] === 'undefined') {
            channelRSDServices[channelId] = {};
        }
        let invalid_rsds = [];
        _.forEach(batchResults,(queryResult)=>{
            let {rsd_id, rsd_service_id} = queryResult;
            if (queryResult.error) {
                console.log(`failed to get rsd data for rsd_service_id:${rsd_service_id}, rsd_id:${rsd_id}`);
            }
            else {
                if (queryResult.service_type !== Globals.RSD_SERVICE_TYPES.MZL) {
                    let result = queryResult.result;
                    if (result.invalid) {
                        invalid_rsds.push({rsd_service_id, rsd_id});
                    }
                    else {
                        let existing_index = _.findIndex(external_rsds,{rsd_id, rsd_service_id});
                        let rsd = {
                            rsd_id,
                            rsd_service_id,
                            name: result.name,
                            description: result.description,
                        }
                        if (existing_index >= 0) {
                            external_rsds[existing_index] = rsd;
                        }
                        else {
                            external_rsds.push(rsd);
                        }
                    }
                }
                // else ( batchResults aren't used for service_type MZL which gets all the rsds at once)
            }
            if (invalid_rsds.length) {
                action.invalid_rsds = invalid_rsds; // non-persistent data
            }
        });
        this.emitStatus();
    },
    onBatchLookupFailed: function(actionId, params, err) {
        console.log("onBatchLookupFailed",err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

});

module.exports = RSDStore;